module.exports = __webpack_public_path__ + "img/203-sahrawi-arab-democratic-republic.66b6b954.svg";